import { Component } from '@angular/core';
import { AppConfigService } from '../../../app-config.service';
import {
  CAISSE_NON_ELIGIBLE_LIEN_QC_FR,
  CAISSE_NON_ELIGIBLE_LIEN_QC_EN,
  CAISSE_NON_ELIGIBLE_LIEN_ON_FR,
  CAISSE_NON_ELIGIBLE_LIEN_ON_EN
} from '../../../../configs/urls.config';
import { ProvinceEnum } from '../../../shared/constants/province.enum';

@Component({
  selector: 'app-erreur-caisse-non-eligible',
  templateUrl: './erreur-caisse-non-eligible.component.html',
  styleUrls: ['./erreur-caisse-non-eligible.component.scss'],
  standalone: false
})
export class ErreurCaisseNonEligibleComponent {
  constructor(private readonly _appConfigService: AppConfigService) {}

  retourAccueil(): void {
    // force la redirection
    window.location.href = this._appConfigService.configData.contexteEnvironnement.urlRetour;
  }

  get link() {
    const langue = this._appConfigService.langue;
    const province = this._appConfigService.province;
    if (langue === 'en') {
      return province === ProvinceEnum.Ontario ? CAISSE_NON_ELIGIBLE_LIEN_ON_EN : CAISSE_NON_ELIGIBLE_LIEN_QC_EN;
    } else {
      return province === ProvinceEnum.Ontario ? CAISSE_NON_ELIGIBLE_LIEN_ON_FR : CAISSE_NON_ELIGIBLE_LIEN_QC_FR;
    }
  }
}
